import Link from 'next/link';
import React, { FunctionComponent, useState } from 'react';

import styles from './index.module.scss';
type Props = {
  name;
  routes;
};

const RouteListMobile: FunctionComponent<Props> = ({ name, routes }) => {
  const [active, setActive] = useState(false);
  return (
    <span className={`${styles.root}`}>
      <span
        className={`label ${styles['_label']} ${active ? styles['_active'] : ''}`}
        onClick={() => setActive(!active)}>
        {name}
      </span>
      <span className={styles['_routes']}>
        {active &&
          routes?.map((val, key) => {
            const { content, slug, page } = val;

            if (content?.carInfo) {
              const data = content.carInfo;
              return (
                <Link key={key} href={`/${data.slug.current}`} legacyBehavior>
                  <div className={`route ${styles['_route']}`}>
                    <h3>{data.name}</h3>
                  </div>
                </Link>
              );
            }

            if (slug) {
              return (
                <Link key={key} href={`/${slug.current}`} legacyBehavior>
                  <div className={`route ${styles['_route']}`}>
                    <h3>{val.overridTitle ? val.overridTitle : page.title}</h3>
                  </div>
                </Link>
              );
            }

            return null;
          })}
      </span>
    </span>
  );
};

export default React.memo(RouteListMobile);
